package learning.components


import antd.button.button
import antd.form.form
import antd.form.formItem
import antd.input.input
import antd.message.message
import com.jingfangpai.common.orm.mapping.Comment
import com.jingfangpai.common.orm.mapping.enums.CommentEntityType
import com.jingfangpai.common.orm.mapping.enums.CommentType
import com.jingfangpai.common.orm.mapping.enums.ContentType
import com.jingfangpai.content.model.ContentVo
import react.*
import react.dom.div
import community.containers.TopicCommentEditPageContext
import external.ckEditor.CKEditor
import external.ckEditor.ClassicEditor
import external.ckEditor.EditorConf
import external.ckEditor.EditorToolbarConf
import kotlinext.js.Object
import kotlinext.js.jsObject
import kotlinx.browser.document
import learning.containers.TcmFaqCommentEditPageContext
import react.dom.attrs
import react.dom.textarea
import react.router.dom.useHistory
import user.service.AuthService

external interface TcmFaqCommentEditProps : RProps {
    var topicId:String
    var commentId:String
}

data class TcmFaqCommentEditContextData(var placeHolderFunction: (param: String) -> Unit)

val TcmFaqCommentEdit = functionalComponent<TcmFaqCommentEditProps> { props ->

    val ctx = useContext(TcmFaqCommentEditPageContext)
    val history = useHistory()
    val (comment,setComment) = useState(Comment().apply {
        entityType = CommentEntityType.Content
        entityId = props.topicId
        type = CommentType.评论
        description = ""
        authorId = AuthService.getUserAuthData()?.id?:""
        createdBy = AuthService.getUserAuthData()?.userName?:""
        weight = 0
    })
    val (topic,setTopic) = useState(ContentVo())

    val (editor,setEditor) = useState<CKEditor?>(null)
    val (editorContentLoaded,setEditorContentLoaded) = useState(false)

    fun onContentChanged(event:dynamic,data:dynamic,editorInstance: CKEditor){
        setEditor(editorInstance)
    }

    fun onEditorInit(editor: CKEditor){
        console.log("onEditorInit",editor)
        setEditor(editor)

        editor.editing.view.change( {writer->
            writer.setStyle( "min-height", "400px", editor.editing.view.document.getRoot() );
        } );
        editor.model.document.on("change:data", {event,data->
            onContentChanged(event,data,editor)
        });
    }

    fun onSave(event: dynamic) {
        editor?.let {
            editor.getData().let{ data ->
                comment.comment = data
            }
        }

        if(comment.comment.isNullOrBlank()){
            message.error("请填写评论内容")
            return;
        }
        message.loading("正在保存",5)
        ctx.save(comment,{ resp->
            if(resp.ok()){
                if(comment.id.isNullOrBlank()){ //新增
                    history.push(CommunityRoute.TopicCommentEdit.link.url.replace(":topicId",props.topicId?:"").replace(":commentId",resp.data?.id?:""))
                }
            }else{
                message.error("抱歉，出错了：${resp.message}")
            }
        },{
            console.log(it)
            message.error("保存失败，${it.message}")
        })
    }

    useEffect(comment) {
        if(editor != null && comment.comment != null && editor.getData().isNullOrBlank() && comment.comment != editor.getData()){ //仅当编辑器内容为空时
            editor.setData(comment.comment!!)
            setEditorContentLoaded(true)
        }
    }

    useEffect(editor){
        console.log("data",editor?.getData())
        if(editor != null && !editorContentLoaded && comment.comment != null && comment.comment != editor.getData()){
            editor.setData(comment.comment!!)
            setEditorContentLoaded(true)
        }
    }

    useEffectOnce{
        if("new" != props.commentId){
            if(props.commentId.length == 32) {
                ctx.getCommentById(props.commentId,{ resp->
                    if(resp.ok() && resp.data !=null){
                        setComment(resp.data!!)
                    }else{
                        message.error("获取回复失败")
                    }
                },{
                    message.error("获取回复失败")
                })

            }
        }
        if(!props.topicId.isNullOrBlank()){
            if(props.topicId.length == 32) {
                ctx.getTopic(ContentType.TcmFaq,props.topicId,{ resp->
                    if(resp.ok() && resp.data !=null){
                        setTopic(resp.data!!)
                    }else{
                        message.error("获取问题失败")
                    }
                },{
                    message.error("获取问题失败")
                })

            }
        }
    }

    useEffectOnce {
        ClassicEditor.create(document.querySelector("#editor"), jsObject<EditorConf> {
            toolbar = jsObject <EditorToolbarConf> {
                alignment = kotlinext.js.js{
                    options = arrayOf("left","right")
                }
                items = arrayOf(
                    "heading",
                    "|",
                    "bold",
                    "italic",
                    "underline",
                    "fontSize",
                    "fontColor",
                    "alignment",
                    "strikethrough",
                    "link",
                    "bulletedList",
                    "numberedList",
                    "|",
                    "outdent",
                    "indent",
                    "|",
                    "imageUpload",
                    "blockQuote",
                    "insertTable",
                    "undo",
                    "redo",
                    "horizontalLine",
                    "removeFormat"
                )
            }
            props.commentId?.let{ id->
                simpleUpload = kotlinext.js.js {
                    // The URL that the images are uploaded to.
                    uploadUrl = "/api/file/upload/ckeditor?entityType=Comment&entityId=${id}"

                    // Enable the XMLHttpRequest.withCredentials property.
                    withCredentials = false

                    // Headers sent along with the XMLHttpRequest to the upload server.
                    /*headers = js {
                        entityType = "Content"
                        entityId = props.id
                    }*/
                }
            }

            language = "zh-cn"
            licenseKey = ""
        }
        )
            .then(::onEditorInit)
            .catch { error ->
                console.error(error);
            }

    }

    div("MeridianEdit") {
        form {
            attrs{
                layout = "horizontal"
            }
            formItem {
                attrs{
                    label = "评论主题"
                }
                input {
                    attrs {
                        value = comment.title ?:"回复：${topic.title?:""}"
                        placeholder = "评论主题"
                        onChange = {event: dynamic ->
                            val _comment = Object.assign(Comment(),comment)
                            _comment.title = event.target.value as String
                            setComment(_comment)
                        }
                    }
                }
            }

            formItem {
                attrs{
                    label = "评论内容"
                }
                div{
                    textarea{
                        attrs{
                            rows = "40"
                        }
                        attrs["id"] = "editor"
                    }
                }
            }
            formItem {
                button {
                    attrs{
                        type = "primary"
                        onClick = ::onSave
                    }
                    +"提交评论"
                }
            }
        }
    }
}